import { isHTMLElement } from '../../typeValidators';
import checkIsCalibreBlockLevelElement from './checkIsCalibreBlockLevelElement';

const isFocusableElement = (node: Node): boolean => {
  if (!node) {
    throw new Error('Element not given');
  }

  if (!isHTMLElement(node)) {
    return false;
  }

  const element = node as HTMLElement;

  const tagName = element.tagName.toLowerCase();

  if (
    ['article', 'figcaption', 'mask', 'path', 'svg'].includes(tagName) ||
    tagName === 'div' && !checkIsCalibreBlockLevelElement(element) ||
    // Standalone images are allowed (they're given `display: block;` in CSS). Also, `<p><a ...><img ...></a></p>` should return true
    tagName !== 'img' && !element.innerText?.trim() && !element.querySelector('img')
  ) {
    return false;
  }

  // skip the embedded tweet header and footer
  const embeddedTweetJunk = element.closest('.rw-embedded-tweet > header, .rw-embedded-tweet > footer');
  if (embeddedTweetJunk) {
    return false;
  }


  const rect = element.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) {
    return false;
  }

  const { display, visibility, opacity } = window.getComputedStyle(element);
  return ['block', 'list-item'].includes(display) && visibility !== 'hidden' && opacity !== '0';
};

export default isFocusableElement;
